import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title, Subtitle } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { MEDICINE, UPDATE_MEDICINE } from './queries';
import { FIELDS } from './new';

const Medicine = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(MEDICINE, { variables: { id } });

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.medicine }));
    }
  }, [data]);

  const { submit: updateMedicine, formStatus, errorMessage } =
    useFormSubmit(UPDATE_MEDICINE, {
      onCompleted: () => navigate('/medicines'),
    });

  const onSubmit = input => {
    updateMedicine({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  return (
    <View>
      <Title>{data?.medicine.name}</Title>

      <Subtitle>Client: {data?.medicine.client.name}</Subtitle>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default Medicine;
